// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/ordini?societaId={id}&stato={stato}&flussoCommerciale={flusso}&destinatarioOrdine={d}&commessaId={cid}&acquirenteId={aid}&dataDa={d}&dataA={d}&q={q}',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","numero":"string","societaId":"number","commessaId":"number","dataOrdine":"string","stato":"string","flussoCommerciale":"string|null","modalitaEvasione":"string|null","destinatarioOrdine":"string|null","acquirenteId":"number|null","totale":"string","preventivoOrigineId":"number|null","commessa":{"id":"number","numero":"string","descrizione":"string","clienteRagioneSociale":"string"},"acquirente":{"id":"number","nome":"string","cognome":"string","unitaCodice":"string"},"preventivoOrigine":{"id":"number","numero":"string"},"righeDaConfigurare":"number","righeDaEsplodere":"number","righeDaTrasformare":"number","righeDaLavorare":"number"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/commesse?societaId={id}',
    requestBody: null,
    response: '{"commesse":[{"id":"number","numero":"string","descrizione":"string","clienteRagioneSociale":"string"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/commesse/:id/acquirenti',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","unitaCodice":"string","nome":"string","cognome":"string"}]}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
